
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { SurveyAnswers, SurveyJsUiClient, SurveyResultView, SurveyView } from '../../backend/backendapi';
import { handleError, initClient } from '../../../api';
import CenterOnParent from '../../util/CenterOnParent';
import AnswersTable from './AnswersTable';
import Spinner from '../../util/Spinner';
import { blobDownload } from '../../../util';

@Component({
  components: {
    AnswersTable,
    CenterOnParent,
    Spinner,
  },
})
export default class AnswersModal extends Vue {
  surveyId: string | null = null;
  surveyResultId : number | null = null;
 
  answers: SurveyAnswers | null = null;

  downloadingPdf = false;

  readonly api = initClient(SurveyJsUiClient);

  public async open(surveyId: string, surveyResultId: number): Promise<void> {
    this.surveyId = surveyId;
    this.surveyResultId = surveyResultId;
    this.answers = null;
    $(this.$refs.modal!).modal('show');
    this.answers = await this.api.getAnswers(surveyId,surveyResultId);
  }

  public dismiss(): void {
    this.surveyId = null;
    this.surveyResultId = null;
    this.answers = null;
    $(this.$refs.modal!).modal('hide');
  }

  async printAnswers(): Promise<void> {
    if(!this.surveyId || !this.surveyResultId) {
      return;
    }
    this.downloadingPdf = true;
    try {
      const pdf = await this.api.getAnswersPdf(this.surveyId, this.surveyResultId);
      blobDownload(pdf.data, pdf.fileName ?? 'answers.pdf');
    } catch (error) {
      handleError(this.$toasted, this.$i18n, error);
    } finally {
      this.downloadingPdf = false;
    }
  }
}
